import React, { Component } from "react";

import { Form, Button, Input, Row, Col, Spin, Modal, Select, Checkbox, Upload } from "antd";
import config from "../config";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import withRouter from "../withRouter";

import FuelDetailsStore from "../store/FuelDetailsStore";
import CompanyAutocomplete from "./CompanyAutocomplete";
import { Link } from "react-router-dom";
import CompanyStore from "../store/CompanyStore";
import { UploadOutlined } from "@ant-design/icons";

class TicketAdd extends Component {
    formRef = React.createRef();
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            show: false,
            ticketId: -1,
            companyId: "",
            loadingSpin: false,
            disabledSaveButton: false,
            waslRegistration: false
        };

        this.fuelStore = new FuelDetailsStore(this);
        this.companyStore = new CompanyStore(this);
    }

    async componentDidMount() {
        if (Number(this.props.getUserData().isadmin) !== -1 || Number(this.props.getUserData().isadmin) !== 3) {
            this.context.viewStateStore.setFuelDetailsStates({
                companyId: this.props.getUserData().userCompanyId,
            });
            await this.setState({
                companyId: this.props.getUserData().userCompanyId,
            });

        }
        const Id = this.props.ticketId;

        if (Id) {
            await this.setState({ loadingSpin: true });
            console.log("tt", Id);
            const getFuelData = await this.fuelStore.getFuelDetails({ fuelId: Id });
            await this.setState({
                companyId: getFuelData.companyId,
                fuelId: getFuelData.fuelId,
            });
            const singleData = await this.companyStore.getCompanyDataById(
                getFuelData.companyId
            );
            console.log("getdata", getFuelData);
            this.setState({ selectedFuelData: getFuelData });
            this.formRef.current.setFieldsValue({
                Diesel: getFuelData.Diesel,
                petrol: getFuelData.petrol,
                companyId: singleData,
            });
            await this.setState({ loadingSpin: false });
        }
    }

    layout = {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
    };

    onTicketDetailsSubmit = async (values) => {
        this.setState({ loading: true });
        console.log(values);
        const TicketDetails = {
            ...values,
            ticketId: this.state.ticketId,
        };

        console.log("first", TicketDetails)
        // const response = await this.fuelStore.addData(data);
        // this.props.response(response);

        this.setState({ loading: false });
    };
    async handleChange(comp) {
        await this.setState({ companyId: comp.value });

        await this.formRef.current.setFieldsValue({ companyId: comp.value });
        if (!this.props.fuelId) {
            this.context.viewStateStore.setFuelDetailsStates({
                companyId: comp.value,
            });
        }
        const data = await this.fuelStore.checkCompany({
            companyId: comp.value,
            fuelId: this.props.fuelId,
            fCompanyId: this.state.selectedFuelData?.companyId,
        });

        if (data?.count > 0) {
            Modal.warning({
                title: "Alert",
                content: "Company is selected for this fuel details."
            });

            this.setState({ disabledSaveButton: true });
        } else {
            this.setState({ disabledSaveButton: false });
        }
        await this.handleSearch();
    }

    async handleSearch() {
        await this.fuelStore.loadData({
            offset: (this.state.currentPage - 1) * this.state.pageSize,
            limit: this.state.pageSize,
            searchField: this.state.searchField,
            companyId: this.state.companyId,
        });
        await this.setState({ loadList: 1 });
    }

    validateFieldsValue = (value, field) => {
        // Check if value contains only numbers
        // const isValid = /^[0-9]+$/.test(value);
        const value1 = value.replace(/[^0-9.]*/g, "");
        console.log(value1);
        if (value1) {
            this.formRef.current.setFieldsValue({ [field]: value1 });
            //   this.setState({ [field]: value1 })
        } else {
            this.formRef.current.setFieldsValue({ [field]: "" });
            //   this.setState({ [field]: value1 })
        }
    };

    closeModal = () => {
        this.props.closeModal();
    };

    render() {
        return (
            <div style={{ padding: 0, height: "100%" }}>
                <div style={{ paddingBottom: "10px", height: "100%" }}>
                    <Spin
                        wrapperClassName="spinClass"
                        spinning={this.state.loadingSpin}
                        fullscreen
                    >
                        <Form
                            // style={{ maxWidth: "100%", padding: 0 }}
                            layout="vertical"
                            onFinish={this.onTicketDetailsSubmit}

                            name="nest-message"
                            ref={this.formRef}
                            className="formClass"
                        >

                            <Row className="overflowFormInputs">
                                <Col span={12} className="formColumnClass">
                                    <Form.Item
                                        name="chassisNo"
                                        label={
                                            <span>
                                                {this.context.translate(
                                                    "_CHASSIS_NUMBER_"
                                                )}{" "}
                                                <span style={{ color: "red" }}>*</span>
                                            </span>
                                        }
                                        required={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: `${this.context.translate(
                                                    "_CHASSIS_NUMBER_"
                                                )} ${this.context.translate(
                                                    "_IS_REQUIRED_"
                                                )}`,
                                            },
                                        ]}
                                    >
                                        <Input />
                                    </Form.Item>

                                    <Form.Item
                                        name="make"
                                        label={
                                            <span>
                                                {this.context.translate(
                                                    "_MAKE_"
                                                )}{" "}
                                                <span style={{ color: "red" }}>*</span>
                                            </span>
                                        }
                                        required={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: `${this.context.translate(
                                                    "_MAKE_"
                                                )} ${this.context.translate(
                                                    "_IS_REQUIRED_"
                                                )}`,
                                            },
                                        ]}
                                    >
                                        <Input />
                                    </Form.Item>

                                    <Form.Item
                                        name="vehicleModel"
                                        label={
                                            <span>
                                                {this.context.translate(
                                                    "_VEHICLE_MODEL_"
                                                )}{" "}
                                                <span style={{ color: "red" }}>*</span>
                                            </span>
                                        }
                                        required={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: `${this.context.translate(
                                                    "_VEHICLE_MODEL_"
                                                )} ${this.context.translate(
                                                    "_IS_REQUIRED_"
                                                )}`,
                                            },
                                        ]}
                                    >
                                        <Input />
                                    </Form.Item>

                                    <Form.Item
                                        name="groupId"
                                        label={this.context.translate(
                                            "_VEHICLE_GROUPS_"
                                        )}
                                    >
                                        <Select />
                                    </Form.Item>

                                    <Form.Item
                                        name=""
                                        label={" "}
                                    >
                                        <Upload
                                            // style={{ marginTop: "15px" }}
                                            name="photo"
                                            listType="picture"
                                            // customRequest={(options) => this.uploadFunction(options)}
                                            // onChange={this.getUploadData}
                                            // onRemove={async () => {
                                            //     await this.userStore.setPhotoFromDb([]);
                                            //     await this.setState({ photo: "", fileList: [] });
                                            // }}
                                            maxCount={1}
                                            accept=".jpg,.png"
                                        // Add the beforeUpload prop to perform file extension validation
                                        // beforeUpload={(file) => this.validateFile(file)}
                                        // {...this.userStore.photoFromDb}
                                        >
                                            <Button className="imgupload" icon={<UploadOutlined />}>
                                                {this.context.translate("_UPLOAD_")}
                                            </Button>
                                        </Upload>
                                    </Form.Item>
                                </Col>
                                <Col span={12} className="formColumnClass">
                                    <Form.Item
                                        name="plateNumber"
                                        label={
                                            <span>
                                                {this.context.translate(
                                                    "_NUMBER_"
                                                )}{" "}
                                                <span style={{ color: "red" }}>*</span>
                                            </span>
                                        }
                                        required={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: `${this.context.translate(
                                                    "_NUMBER_"
                                                )} ${this.context.translate(
                                                    "_IS_REQUIRED_"
                                                )}`,
                                            },
                                        ]}
                                    >
                                        <Input />
                                    </Form.Item>

                                    <Form.Item
                                        name="plateType"
                                        label={
                                            <span>
                                                {this.context.translate(
                                                    "_PLATE_TYPE_"
                                                )}{" "}
                                                <span style={{ color: "red" }}>*</span>
                                            </span>
                                        }
                                        required={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: `${this.context.translate(
                                                    "_PLATE_TYPE_"
                                                )} ${this.context.translate(
                                                    "_IS_REQUIRED_"
                                                )}`,
                                            },
                                        ]}
                                    >
                                        <Select

                                            options={[
                                                { label: "Private", value: "private" },
                                                { label: "Public", value: "public" },

                                            ]}
                                        // onSelect={(val) => {
                                        //     this.showPulseFields(val);
                                        // }}
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        name="location"
                                        label={
                                            <span>
                                                {this.context.translate(
                                                    "_LOCATION_"
                                                )}{" "}
                                                <span style={{ color: "red" }}>*</span>
                                            </span>
                                        }
                                        required={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: `${this.context.translate(
                                                    "_LOCATION_"
                                                )} ${this.context.translate(
                                                    "_IS_REQUIRED_"
                                                )}`,
                                            },
                                        ]}
                                    >
                                        <Input />
                                    </Form.Item>

                                    <Form.Item
                                        name=""
                                        label={" "}
                                    >
                                        <Checkbox style={{ marginTop: "10px" }} checked={this.state.waslRegistration}
                                            onChange={async (e) => {
                                                await this.setState({
                                                    waslRegistration: e.target.checked,
                                                });
                                            }}
                                        />&nbsp;{this.context.translate("_REQUIRE_WASL_INTEGRATION_")}
                                    </Form.Item>
                                    {this.state.waslRegistration &&

                                        <>
                                            <Form.Item
                                                name="sequenceNo"
                                                label={
                                                    <span>
                                                        {this.context.translate(
                                                            "_SEQUENCE_NUMBER_"
                                                        )}{" "}
                                                        <span style={{ color: "red" }}>*</span>
                                                    </span>
                                                }
                                                required={false}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: `${this.context.translate(
                                                            "_SEQUENCE_NUMBER_"
                                                        )} ${this.context.translate(
                                                            "_IS_REQUIRED_"
                                                        )}`,
                                                    },
                                                ]}
                                            >
                                                <Input />
                                            </Form.Item>

                                            <Form.Item
                                                name="location"
                                                label={
                                                    <span>
                                                        {this.context.translate(
                                                            "_PLATE_TYPE_ACTIVITY_"
                                                        )}{" "}
                                                        <span style={{ color: "red" }}>*</span>
                                                    </span>
                                                }
                                                required={false}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: `${this.context.translate(
                                                            "_PLATE_TYPE_ACTIVITY_"
                                                        )} ${this.context.translate(
                                                            "_IS_REQUIRED_"
                                                        )}`,
                                                    },
                                                ]}
                                            >
                                                <Input />
                                            </Form.Item>
                                        </>
                                    }
                                </Col>
                            </Row>

                            <div className="formFooter">
                                <Button
                                    className="formsCancelButton"
                                    onClick={() => this.closeModal()}
                                >
                                    {this.context.translate(
                                        "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                                    )}
                                </Button>
                                <Button
                                    htmlType="submit"
                                    className="formsSaveButton"
                                // onClick={() => this.onExcelSubmit()}
                                >
                                    {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
                                </Button>
                            </div>
                        </Form>
                    </Spin>
                </div>
            </div>
        );
    }
}

TicketAdd.contextType = StoreContext;
export default observer(withRouter(TicketAdd));
